import React, { useEffect, useMemo, useState } from 'react'
import { const_var, params } from '../../../../../redux/reducers/reducer'
import WallNameTemplete from '../../../WallName/WallNameTemplete';

const WallName = () => {
    const [porchOffset, setPorchOffset] = useState(0);

    const backLeftPosState = useMemo(() => {
        let offset = false;
        if((params.leanB_p_w && params.lean_p_w) < 9) {
            if((params.leanB_p_pos - params.leanB_p_d / 2 - 2.5 < -params.p_w / 2 - 1) && (params.lean_p_pos - params.lean_p_d / 2 - 2.5 < -(params.p_d / 2 + 1))){
                offset = true;
            }
        }
        
        return offset;
    }, [params.leanB_p_pos, params.leanB_p_d, params.p_w, params.lean_p_pos, params.lean_p_d, params.p_d, params.leanB_p_w, params.lean_p_w])

    const backRightPosState = useMemo(() => {
        let offset = false;
        if((params.leanB_p_w && params.leanR_p_w) < 9) {
            if((params.leanB_p_pos + params.leanB_p_d / 2 + 2.5 > params.p_w / 2 + 1) && (params.leanR_p_pos - params.leanR_p_d / 2 - 2.5 < -(params.p_d / 2 + 1))){
                offset = true;
            }
        }
        
        return offset;
    }, [params.leanB_p_pos, params.leanB_p_d, params.p_w, params.leanR_p_pos, params.leanR_p_d, params.p_d, params.leanB_p_w, params.leanR_p_w])
    
    useEffect(() => {
        if(params.add_left_back_lean_porch && !params.add_right_back_lean_porch) {
            setPorchOffset(-params.lean_p_w / 2)
        } else if(!params.add_left_back_lean_porch && params.add_right_back_lean_porch){
            setPorchOffset(params.leanR_p_w / 2)
        } else {
            setPorchOffset(0)
        }
    }, [params.add_left_back_lean_porch, params.add_right_back_lean_porch, params.lean_p_w, params.leanR_p_w])


    let wallTemplates = [
        { position: [porchOffset, 0, -(params.p_d / 2 + params.leanB_p_w + 1)], rotation: [0, Math.PI, 0], slopeAngle: 60, value: 'Back Lean Side' },
        { position: [(params.leanB_p_d / 2 + (backRightPosState ? -0.5 : 1)), backRightPosState ? 0.7 : 0, -(params.p_d / 2 + params.leanB_p_w / 2)], rotation: [0, Math.PI / 2, 0], slopeAngle: (backRightPosState ? 0 : 60), value: 'Back Lean Front' },
        { position: [-(params.leanB_p_d / 2 + (backLeftPosState ? -0.5 : 1)), backLeftPosState ? 0.7 : 0, -(params.p_d / 2 + params.leanB_p_w / 2)], rotation: [0, -Math.PI / 2, 0], slopeAngle: (backLeftPosState ? 0 : 60), value: 'Back Lean Back' }
    ]

    if(params.add_storage_check_back){
        if(params.backLeanStoragePosition != 0){
            let positionX = (params.backLeanStoragePosition!=0)?(params.leanB_p_d / -2  +  Math.round(params.backLeanStoragePosition))+ 0.01:params.leanB_p_d /-2 + parseInt(params.add_storage_back)+ 0.01;
            let backStorage = {
                    position: [positionX, 0, -(params.p_d / 2 + params.leanB_p_w / 2)], 
                    rotation: [0, -Math.PI / 2, 0], 
                    slopeAngle: 60,
                    value:  'Back Lean Storage Back'
                };
    
            wallTemplates = [...wallTemplates,backStorage]
        }
        if(params.backLeanStoragePosition != params.leanB_p_d - parseInt(params.add_storage_back) - 0.2){
            let positionX = (params.backLeanStoragePosition!=0)?(params.leanB_p_d / -2  + parseInt(params.add_storage_back) + Math.round(params.backLeanStoragePosition))+ 0.01:params.leanB_p_d /-2 + parseInt(params.add_storage_back)+ 0.01;
            let backStorage = {
                    position: [positionX, 0, -(params.p_d / 2 + params.leanB_p_w / 2)], 
                    rotation: [0, Math.PI / 2, 0], 
                    slopeAngle: 60,
                    value:  'Back Lean Storage Front'
                };
    
            wallTemplates = [...wallTemplates,backStorage]
        }
    }

    return (
        <>
            {wallTemplates.map((template, index) => (
                <WallNameTemplete
                    key={index}
                    position={template.position}
                    rotation={template.rotation}
                    value={template.value}
                    slopeAngle={template.slopeAngle}
                />
            ))}
        </>
    )
}

export default WallName